<template>
  <footer class="footer">
    <div class="container-fluid">
      <ul class="nav">
        <li class="nav-item">
          <a class="nav-link" href="">
            Licenses
          </a>
        </li>
      </ul>
    </div>
  </footer>
</template>
<script>
  export default {
    data() {
      return {
      }
    }
  };
</script>
<style>
</style>
